/**
 * Utility function for smooth scrolling to an element
 * @param elementId - The ID of the element to scroll to
 */
export const smoothScrollTo = (elementId: string): void => {
    const element = document.getElementById(elementId);
    if (!element) return;

    // Get the element's position relative to the viewport
    const rect = element.getBoundingClientRect();

    // Get the current scroll position
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetPosition = rect.top + scrollTop + 16; // 16px extra padding

    // Scroll to the target position with smooth behavior
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
};
